import React, { useState, useEffect } from "react";
import {
  Tabs,
  Tab,
  Box,
  Paper,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  CircularProgress,
  Badge,
  Tooltip,
  Avatar,
  Stack,
} from "@mui/material";
import TabPanel from "../../../component/TabPanel";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ControlledTable from "../../../component/ControlledTable";

import { useDispatch, useSelector } from "react-redux";
import { crmLeadsListTable as tableDef } from "../../../config/grid-columns-defs";
import { handleAxiosError } from "../../../config/action-config";
import { Controller, useForm } from "react-hook-form";
import { showAlert } from "../../../actions/alert";
import { useNavigate } from "react-router-dom";
import {
  createCommission,
  getCompanyList,
  getPartners,
} from "../../../api/commissions";
import {
  createSales,
  getIndustryList,
  getSalesList,
  getStageList,
} from "../../../api/sales";

import { makeStyles } from "@material-ui/core";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import dayjs from "dayjs";
import {
  createCrmLeads,
  getCrmCompanyList,
  getCrmLeadsList,
  postCrmLeadsCall,
  postCrmLeadsEmail,
  postCrmLeadsLinkedIn,
} from "../../../api/crmLeads";
import CloudRepList from "../cloudRep/list.cloudrep";
import { getEmployeeList, getSalesRepList } from "../../../api/employee";
import { getCloudRepList } from "../../../api/cloudRep";
import BetterControlledTable from "../../../component/BetterControlledTable";
import { CountryCodes } from "../../../countryCodes";
import SearchAndLoadMoreDropdown from "../../../component/SearchAndLoadMoreDropdown";
import CRMLeadsListCard from "./list.crmleads.cards";
import {
  CallEndOutlined,
  CircleNotifications,
  Email,
  EmailOutlined,
  LinkedIn,
  MailOutline,
} from "@mui/icons-material";
import ItemDialogTabEmail from "./item.dialog.email.desc";
import ItemDialogTabCall from "./item.dialog.call.desc";
import ItemDialogTabLinkedIn from "./item.dialog.linkedin";
// const useStyles = makeStyles((theme) => ({
//   textfeild: {
//     "& .MuiFilledInput-root": {
//       color: "#fff !important",
//     },
//   },
// }));

export default function CrmLeadsList() {
  //const classes = useStyles();
  let obj = tableDef.find((o) => o.headerName === "Action");
  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [tabIndex, setTabIndex] = useState(user.role === "User" ? 1 : 0);
  const [totalCount, setTotalCount] = useState(0);
  const [rows, setRows] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [company, setCompany] = useState("");
  const [industry, setIndustry] = useState("");
  const [companyListData, setCompanyListData] = useState([]);
  const [industryListData, setIndustryListData] = useState([]);
  const [stageListData, setStageListData] = useState([
    { stage_id: 3, stage_display: "Demo/Meeting", stage_value: 4 },
    { stage_id: 4, stage_display: "Proposal/SOW", stage_value: 5 },
    { stage_id: 5, stage_display: "Negotiation/Commitment", stage_value: 6 },
    { stage_id: 6, stage_display: "Opportunity Won", stage_value: 7 },
  ]);
  const [stage, setStage] = useState("");
  const [priority, setPriority] = useState("");
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [employeesList, setEmployeesList] = useState([]);
  const [cloudRepsList, setCloudRepsList] = useState([]);
  const [queryFilters, setQueryFilters] = useState({
    companyname: "",
    industry: "",
    priority: "",
    stage: user.role === "User" ? "Lead Qualification" : "Raw",
    sales_rep: "",
    designation: "",
    state: "",
  });
  const [crmTableRefreshCount, setCrmTableRefreshCount] = useState(0);
  const [selectedStage, setSelectedStage] = useState("");
  const [itemDialogCall, setItemDialogCall] = useState(false);
  const [itemDialogLinkedIn, setItemDialogLinkedIn] = useState(false);
  const [itemDialogEmail, setItemDialogEmail] = useState(false);
  const [leadId, setLeadId] = useState("");
  const onItemDialogEmailSubmit = async (postData) => {
    const combineData = { ...postData, lead_id: leadId };
    try {
      const { data } = await postCrmLeadsEmail(combineData, user.token);
      setItemDialogEmail(false);
      refreshTable();
      dispatch(showAlert(data.msg));
    } catch (error) {
      setItemDialogEmail(false);
      handleAxiosError(error, dispatch);
    }
  };
  const onItemDialogCallSubmit = async (postData) => {
    const combineData = { ...postData, lead_id: leadId };
    try {
      const { data } = await postCrmLeadsCall(combineData, user.token);
      setItemDialogCall(false);
      refreshTable();
      dispatch(showAlert(data.msg));
    } catch (error) {
      setItemDialogCall(false);
      handleAxiosError(error, dispatch);
    }
  };
  const onItemDialogLinkedInSubmit = async (postData) => {
    const combineData = { ...postData, lead_id: leadId };
    try {
      const { data } = await postCrmLeadsLinkedIn(combineData, user.token);
      setItemDialogLinkedIn(false);
      refreshTable();
      dispatch(showAlert(data.msg));
    } catch (error) {
      setItemDialogLinkedIn(false);
      handleAxiosError(error, dispatch);
    }
  };
  const handleVisibilityClick = (item) => {
    navigate(`${item.lead_id}`);
  };
  const handleEmailClick = (params) => {
    navigate(`/crmLeadsEmails/${params.data.lead_id}`);
  };
  const handleCallClick = (params) => {
    navigate(`/crmLeadsCalls/${params.data.lead_id}`);
  };
  const handleLinkedInClick = (params) => {
    navigate(`/crmLeadsLinkedIn/${params.data.lead_id}`);
  };
  const handleMailIconClick = (data) => {
    setItemDialogEmail(true);
    //  window.location.href = 'https://outlook.live.com/mail/inbox';
    // console.log("params========", params);
    setLeadId(data?.lead_id);
    const recipientEmail = data?.email;
    const emailSubject = "";
    const emailBody = "";
    // const outlookMailUrl = `mailto:${recipientEmail}`;
    // window.location.replace(outlookMailUrl);
    const outlookMailUrl = `mailto:${recipientEmail}?subject=${encodeURIComponent(
      emailSubject
    )}&body=${encodeURIComponent(emailBody)}`;
    window.location.replace(outlookMailUrl);
  };
  const handleCallIconClick = (data) => {
    setItemDialogCall(true);
    setLeadId(data?.lead_id);
    const appScheme = "tel:+14083662521";
    // Open the app in a new window or tab
    window.location.replace(appScheme);
  };
  const handleLinkedInIconClick = (data) => {
    setItemDialogLinkedIn(true);
    setLeadId(data?.lead_id);
    window.open("https://www.linkedin.com/company/vastedge");
    // const appScheme = "https://www.linkedin.com/company/vastedge";
    // window.location.replace(appScheme);
  };
  useEffect(() => {
    addAdditionalColumn(obj, dispatch);
  }, []);
  function addAdditionalColumn(obj, dispatch) {
    if (obj === undefined) {
      tableDef.unshift({
        headerName: "Action",
        field: "actions",
        resizable: true,
        wrapText: true,
        autoHeight: true,
        minWidth: 190,
        headerClass: "justify-center",
        cellClass: "justify-center",
        cellRendererFramework: (params) => (
          <>
            <Tooltip title="Email follow up" arrow>
              <IconButton color="primary" className="email icon-button-bkg">
                <Email
                  onClick={() => {
                    dispatch({ type: "EMAILFOLLOWUP", data: params.data });
                  }}
                  //color="#E32C28"
                  style={{ color: "#fff", fontSize: 16 }}
                />
              </IconButton>
            </Tooltip>

            {params?.data?.email_count ? (
              <Tooltip title="Email follow up count" arrow>
                <IconButton
                  onClick={() => handleEmailClick(params)}
                  color="primary"
                  style={{
                    position: "absolute",
                    top: 19,
                    bottom: 0,
                    right: 135,
                  }}
                  className="number-icon-badge"
                >
                  <Badge
                    color="primary"
                    style={{
                      cursor: "pointer",
                      userSelect: "none", // Prevent text selection
                    }}
                    // sx={{ bgcolor: "#4caf50" }}

                    badgeContent={
                      params?.data?.email_count > 9
                        ? "9+"
                        : params?.data?.email_count
                    }
                    max={99} // Set a maximum count to prevent overflow if count is too large
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  ></Badge>
                </IconButton>
              </Tooltip>
            ) : (
              <></>
            )}
            {/* <Badge badgeContent={4} color="primary">
              <MailOutline color="action" />
            </Badge> */}

            <Tooltip title="Call follow up" arrow>
              <IconButton color="primary" className="call icon-button-bkg">
                <CallEndOutlined
                  onClick={() => {
                    dispatch({ type: "CALLFOLLOWUP", data: params.data });
                  }}
                  color="primary"
                  style={{ color: "#fff", fontSize: 16 }}
                />
              </IconButton>
            </Tooltip>
            {params?.data?.call_count ? (
              <Tooltip title="Call follow up count" arrow>
                <IconButton
                  color="primary"
                  style={{
                    position: "absolute",
                    top: 19,
                    bottom: 0,
                    right: 94,
                  }}
                  className="number-icon-badge"
                >
                  {/* <CircleNotifications
                  onClick={() => handleCallClick(params.data)}
                  color="primary"
                /> */}
                  {params?.data?.call_count && (
                    <Badge
                      onClick={() => handleCallClick(params)}
                      color="primary"
                      // sx={{ bgcolor: "#4caf50" }}
                      badgeContent={
                        params?.data?.call_count > 9
                          ? "9+"
                          : params?.data?.call_count
                      }
                      max={99} // Set a maximum count to prevent overflow if count is too large
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    ></Badge>
                  )}
                </IconButton>
              </Tooltip>
            ) : (
              <></>
            )}
            <Tooltip title="Linked In follow up" arrow>
              <IconButton color="primary" className="linkedin icon-button-bkg">
                <LinkedIn
                  style={{ color: "#fff", fontSize: 16 }}
                  onClick={() => {
                    dispatch({ type: "LINKEDINFOLLOWUP", data: params.data });
                  }}
                  color="primary"
                />
              </IconButton>
            </Tooltip>

            {params?.data?.linkedinchat_count ? (
              <Tooltip title="Linked In follow up count" arrow>
                <IconButton
                  onClick={() => handleLinkedInClick(params)}
                  color="primary"
                  style={{
                    position: "absolute",
                    top: 19,
                    bottom: 0,
                    right: 54,
                  }}
                  className="number-icon-badge"
                >
                  <Badge
                    color="primary"
                    style={{
                      cursor: "pointer",
                      userSelect: "none", // Prevent text selection
                    }}
                    // sx={{ bgcolor: "#4caf50" }}

                    badgeContent={
                      params?.data?.linkedinchat_count > 9
                        ? "9+"
                        : params?.data?.linkedinchat_count
                    }
                    max={99} // Set a maximum count to prevent overflow if count is too large
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  ></Badge>
                </IconButton>
              </Tooltip>
            ) : (
              <></>
            )}
            <IconButton
              sx={{ ml: 1 }}
              color="info"
              onClick={() => {
                dispatch({ type: "VIEW", data: params.data });
              }}
              className="p-0"
            >
              <VisibilityIcon
                //fontSize="inherit"
                //size="10px"
                className="p-0 "
                style={{ fontSize: 24 }}
              />
            </IconButton>
          </>
        ),
      });
    }
  }
  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "VIEW":
        dispatch({ type: "" });
        navigate(`${dialogAction.data.lead_id}`);
        break;
      case "EMAILFOLLOWUP":
        dispatch({ type: "" });
        handleMailIconClick(dialogAction.data);

        break;
      case "CALLFOLLOWUP":
        dispatch({ type: "" });
        handleCallIconClick(dialogAction.data);
        break;
      case "LINKEDINFOLLOWUP":
        dispatch({ type: "" });
        handleLinkedInIconClick(dialogAction.data);
        break;
      default:
        break;
    }
  }, [dialogAction]);

  useEffect(() => {
    if (
      (queryFilters.companyname && queryFilters.companyname.length >= 3) ||
      (queryFilters.designation && queryFilters.designation.length >= 3) ||
      (queryFilters.state && queryFilters.state.length >= 3)
    ) {
      refreshTable();
    } else if (
      (!queryFilters.companyname || queryFilters.companyname.length === 0) &&
      (!queryFilters.designation || queryFilters.designation.length === 0) &&
      (!queryFilters.state || queryFilters.state.length === 0)
    ) {
      console.log("length==", queryFilters.companyname?.length);
      refreshTable();
    }
    return;
  }, [
    queryFilters.companyname,
    queryFilters.industry,
    queryFilters.priority,
    queryFilters.stage,
    queryFilters.sales_rep,
    queryFilters.designation,
    queryFilters.state,
  ]);

  async function getRows(limit, offset) {
    try {
      const { data } = await getCrmLeadsList(
        {
          limit,
          offset,
          companyname: queryFilters.companyname,
          industry: queryFilters.industry,
          priority: queryFilters.priority,
          stage: `'${queryFilters.stage}'`,
          sales_rep: queryFilters.sales_rep,
          designation: queryFilters.designation,
          state: queryFilters.state,
        },
        user.token
      );
      let filtersApplied = Object.keys(queryFilters).some(
        (k) => queryFilters[k]
      );
      return {
        rows: data.data,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  useEffect(() => {
    industryList();
    companyList();
    // stageList();
    employeeList();
    cloudRepList();
  }, []);
  function refreshTable(e) {
    e?.preventDefault();
    setCrmTableRefreshCount((prev) => prev + 1);
  }
  function onQueryFilterChange({ target }) {
    const { name, value } = target;
    setQueryFilters((prev) => ({ ...prev, [name]: value }));
  }
  // useEffect(() => {
  //   if (tabIndex === 0) {
  //     setStage("Raw");
  //   } else if (tabIndex === 1) {
  //     setStage("Lead Qualification");
  //   } else if (tabIndex === 2) {
  //     setStage("Prospecting,Demo/Meeting,Proposal,Negotiation");
  //   } else if (tabIndex === 3) {
  //     setStage("Opportunity Won");
  //   } else if (tabIndex === 4) {
  //     setStage("Lost");
  //   } else if (tabIndex === 5) {
  //   }
  // }, [tabIndex]);
  async function industryList() {
    try {
      const { data } = await getIndustryList(user.token);
      setIndustryListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function companyList() {
    try {
      const { data } = await getCrmCompanyList(user.token);
      setCompanyListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  // async function stageList() {
  //   try {
  //     const { data } = await getStageList(user.token);
  //     setStageListData(data.records);
  //   } catch (error) {
  //     handleAxiosError(error, dispatch);
  //   }
  // }
  const employeeList = async () => {
    const token = user.token;
    return await getSalesRepList(
      {
        name: "",
      },
      token
    )
      .then((res) => {
        // const role = "SalesPerson";
        // const filtteredRole = res.data.EmployeeList.filter(
        //   (e) => e.role === role
        // );

        setEmployeesList(res.data.data.SalesRepList);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  const cloudRepList = async () => {
    const token = user.token;
    return await getCloudRepList({}, token)
      .then((res) => {
        setCloudRepsList(res.data.data.CloudRep);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  const resetFilterFields = () => {
    setQueryFilters({
      companyname: "",
      industry: "",
      priority: "",
      sales_rep: "",
      designation: "",
      state: "",
      stage: tabIndex === 3 ? "" : tabIndex === 0 ? "Raw" : selectedStage,
    });
  };

  return (
    <>
      <Box sx={{ flexGrow: 1, px: 5, py: 2 }} style={{ padding: "0px" }}>
        {/*Start Updated Filter UI Sneha(19Ot23) */}
        {tabIndex !== 5 && (
          <Box className="filter-box">
            <Stack
              sx={{ flexDirection: { xs: "column", md: "row" } }}
              direction="row"
              spacing={1}
            >
              <TextField
                size="small"
                // className={classes.textfeild}
                className="company-selectfeild"
                name="companyname"
                label="Company Name"
                type="text"
                sx={{ background: "#fff" }}
                variant="outlined"
                value={queryFilters.companyname}
                onChange={onQueryFilterChange}
                //fullWidth
              />

              <FormControl size="small" className="industry-selectfeild">
                <InputLabel id="demo-simple-select-label" size="small">
                  Industry
                </InputLabel>
                <Select
                  sx={{ background: "#fff" }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  size="small"
                  name="industry"
                  // value={industry}
                  label="Industry"
                  // onChange={(e) => {
                  //   setIndustry(e.target.value);
                  // }}
                  value={queryFilters.industry}
                  onChange={onQueryFilterChange}
                >
                  {industryListData.map((c, i) => (
                    <MenuItem key={i} value={c.industry_display_value}>
                      {c.industry_display_value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl size="small" className="priority-selectfeild">
                <InputLabel id="demo-simple-select-label" size="small">
                  Priority
                </InputLabel>
                <Select
                  //className={classes.textfeild}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="priority"
                  // value={priority}
                  label="Priority"
                  size="small"
                  sx={{ background: "#fff" }}
                  // onChange={(e) => {
                  //   setPriority(e.target.value);
                  // }}
                  value={queryFilters.priority}
                  onChange={onQueryFilterChange}
                >
                  <MenuItem value="1">1</MenuItem>
                  <MenuItem value="2">2</MenuItem>
                  <MenuItem value="3">3</MenuItem>
                  <MenuItem value="4">4</MenuItem>
                  <MenuItem value="5">5</MenuItem>
                </Select>
              </FormControl>
              <FormControl size="small" className="SalesRep-selectfeild">
                <InputLabel id="demo-simple-select-label" size="small">
                  Sales Rep
                </InputLabel>
                <Select
                  //className={classes.textfeild}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="sales_rep"
                  // value={priority}
                  label="Sales Rep"
                  size="small"
                  sx={{ background: "#fff" }}
                  // onChange={(e) => {
                  //   setPriority(e.target.value);
                  // }}
                  value={queryFilters.sales_rep}
                  onChange={onQueryFilterChange}
                >
                  {employeesList.map((e, i) => (
                    <MenuItem key={i} value={e.id}>
                      {e.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {tabIndex === 3 && (
                <FormControl size="small" style={{ width: "175px" }}>
                  <InputLabel
                    id="demo-simple-select-label"
                    size="small"
                    fullWidth
                  >
                    Stage
                  </InputLabel>
                  <Select
                    //className={classes.textfeild}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="stage"
                    // value={stage}
                    label="Stage"
                    size="small"
                    sx={{ background: "#fff" }}
                    // onChange={(e) => {
                    //   setStage(e.target.value);
                    // }}
                    value={queryFilters.stage}
                    onChange={onQueryFilterChange}
                  >
                    {stageListData.map((s, i) => (
                      <MenuItem key={i} value={s.stage_display}>
                        {s.stage_display}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}

              <TextField
                size="small"
                //className={classes.textfeild}
                name="designation"
                label="Designation"
                type="text"
                sx={{ background: "#fff" }}
                variant="outlined"
                value={queryFilters.designation}
                onChange={onQueryFilterChange}
              />
              <TextField
                size="small"
                //className={classes.textfeild}
                name="state"
                label="State"
                type="text"
                sx={{ background: "#fff" }}
                variant="outlined"
                value={queryFilters.state}
                onChange={onQueryFilterChange}
              />
              <Button
                className="reset-button"
                style={{ padding: "5px" }}
                onClick={() => {
                  resetFilterFields();
                }}
              >
                Reset
              </Button>
            </Stack>
          </Box>
        )}
        {/*End Updated Filter UI Sneha(19Ot23) */}

        {/*--Sneha-- {tabIndex !== 5 && (
          <Box className="pmt-filter-box">
            <Grid
              container
              className="report-filter-box"
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            >
              <Grid item lg={2} md={2} sm={4} xs={12}>
                <TextField
                  size="small"
                  className={classes.textfeild}
                  name="companyname"
                  fullWidth
                  label="Company Name"
                  type="text"
                  sx={{ background: "#fff" }}
                  variant="outlined"
                  value={queryFilters.companyname}
                  onChange={onQueryFilterChange}
                />
              </Grid>
              {/* <Grid item lg={2} md={2} sm={4} xs={12}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label" size="small">
                    Company Name
                  </InputLabel>
                  <Select
                    className={classes.textfeild}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="companyname"
                    // value={company}
                    label="Company Name"
                    size="small"
                    sx={{ background: "#fff" }}
                    // onChange={(e) => {
                    //   setCompany(e.target.value);
                    // }}
                    value={queryFilters.companyname}
                    onChange={onQueryFilterChange}
                  >
                    {companyListData.map((c, i) => (
                      <MenuItem key={i} value={c.company_name}>
                        {c.company_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}
        {/*--Sneha-- 
              <Grid item lg={2} md={2} sm={4} xs={12}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label" size="small">
                    Industry
                  </InputLabel>
                  <Select
                    sx={{ background: "#fff" }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    size="small"
                    name="industry"
                    // value={industry}
                    label="Industry"
                    // onChange={(e) => {
                    //   setIndustry(e.target.value);
                    // }}
                    value={queryFilters.industry}
                    onChange={onQueryFilterChange}
                  >
                    {industryListData.map((c, i) => (
                      <MenuItem key={i} value={c.industry_display_value}>
                        {c.industry_display_value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item lg={2} md={2} sm={4} xs={12}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label" size="small">
                    Priority
                  </InputLabel>
                  <Select
                    className={classes.textfeild}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="priority"
                    // value={priority}
                    label="Priority"
                    size="small"
                    sx={{ background: "#fff" }}
                    // onChange={(e) => {
                    //   setPriority(e.target.value);
                    // }}
                    value={queryFilters.priority}
                    onChange={onQueryFilterChange}
                  >
                    <MenuItem value="1">1</MenuItem>
                    <MenuItem value="2">2</MenuItem>
                    <MenuItem value="3">3</MenuItem>
                    <MenuItem value="4">4</MenuItem>
                    <MenuItem value="5">5</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item lg={2} md={2} sm={4} xs={12}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label" size="small">
                    Sales Rep
                  </InputLabel>
                  <Select
                    className={classes.textfeild}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="sales_rep"
                    // value={priority}
                    label="Sales Rep"
                    size="small"
                    sx={{ background: "#fff" }}
                    // onChange={(e) => {
                    //   setPriority(e.target.value);
                    // }}
                    value={queryFilters.sales_rep}
                    onChange={onQueryFilterChange}
                  >
                    {employeesList.map((e, i) => (
                      <MenuItem key={i} value={e.id}>
                        {e.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {tabIndex === 3 && (
                <Grid item lg={3} md={3} sm={4} xs={12}>
                  <FormControl
                    full
                    Width
                    size="small"
                    style={{ width: "175px" }}
                  >
                    <InputLabel id="demo-simple-select-label" size="small">
                      Stage
                    </InputLabel>
                    <Select
                      className={classes.textfeild}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="stage"
                      // value={stage}
                      label="Stage"
                      size="small"
                      sx={{ background: "#fff" }}
                      // onChange={(e) => {
                      //   setStage(e.target.value);
                      // }}
                      value={queryFilters.stage}
                      onChange={onQueryFilterChange}
                    >
                      {stageListData.map((s, i) => (
                        <MenuItem key={i} value={s.stage_display}>
                          {s.stage_display}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              <Grid item lg={2} md={2} sm={4} xs={12}>
                <TextField
                  size="small"
                  className={classes.textfeild}
                  name="designation"
                  fullWidth
                  label="Designation"
                  type="text"
                  sx={{ background: "#fff" }}
                  variant="outlined"
                  value={queryFilters.designation}
                  onChange={onQueryFilterChange}
                />
              </Grid>
              <Grid item lg={2} md={2} sm={4} xs={12}>
                <TextField
                  size="small"
                  className={classes.textfeild}
                  name="state"
                  fullWidth
                  label="State"
                  type="text"
                  sx={{ background: "#fff" }}
                  variant="outlined"
                  value={queryFilters.state}
                  onChange={onQueryFilterChange}
                />
              </Grid>
              <Grid item lg={2} md={2} sm={4} xs={12}>
                <Button
                  className="export-button"
                  style={{ padding: "5px" }}
                  onClick={() => {
                    resetFilterFields();
                  }}
                >
                  Reset
                </Button>
              </Grid>
            </Grid>
          </Box>
        )} --*/}
        <Box className="tbl-box">
          <Box sx={{ width: "100%", mb: 1 }} className="project-tabs">
            {tabIndex === 5 ? (
              <></>
            ) : (
              <Button
                variant="contained"
                //style={{ padding: "5px 7px" }}
                onClick={() => {
                  setCreateDialogOpen(true);
                }}
                className="add-button btn-align-right"
                size="small"
              >
                Add New
              </Button>
            )}
            <Tabs
              value={tabIndex}
              onChange={(_e, nv) => {
                setTabIndex(nv);
                if (nv === 0) {
                  setQueryFilters({
                    stage: "Raw",
                    companyname: "",
                    industry: "",
                    priority: "",
                    sales_rep: "",
                    designation: "",
                    state: "",
                  });
                  setSelectedStage("Raw");
                } else if (nv === 1) {
                  setQueryFilters({
                    stage: "Lead Qualification",
                    companyname: "",
                    industry: "",
                    priority: "",
                    sales_rep: "",
                    designation: "",
                    state: "",
                  });
                  setSelectedStage("Lead Qualification");
                } else if (nv === 2) {
                  setQueryFilters({
                    stage: "Prospecting",
                    //stage: "'Prospecting','Demo/Meeting','Proposal','Negotiation'",
                    companyname: "",
                    industry: "",
                    priority: "",
                    sales_rep: "",
                    designation: "",
                    state: "",
                  });
                  setSelectedStage("Prospecting");
                } else if (nv === 3) {
                  setQueryFilters({
                    // stage: "Opportunity Won",
                    stage: "",
                    companyname: "",
                    industry: "",
                    priority: "",
                    sales_rep: "",
                    designation: "",
                    state: "",
                  });
                  setSelectedStage("Opportunity Won");
                } else if (nv === 4) {
                  setQueryFilters({
                    stage: "Lost",
                    companyname: "",
                    industry: "",
                    priority: "",
                    sales_rep: "",
                    designation: "",
                    state: "",
                  });
                  setSelectedStage("Lost");
                }
              }}
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              aria-label="scrollable force tabs example"
              sx={{ minHeight: "30px", height: "30px" }}
            >
              <Tab
                label="Raw"
                id="simple-tab-0"
                aria-controls="simple-tabpanel-0"
                sx={{ minHeight: "30px", height: "30px" }}
              />
              <Tab
                label="Leads"
                id="simple-tab-1"
                aria-controls="simple-tabpanel-1"
                sx={{ minHeight: "30px", height: "30px" }}
              />
              <Tab
                label="Prospects"
                id="simple-tab-2"
                aria-controls="simple-tabpanel-2"
                sx={{ minHeight: "30px", height: "30px" }}
              />
              <Tab
                label="Opportunities"
                id="simple-tab-3"
                aria-controls="simple-tabpanel-3"
                sx={{ minHeight: "30px", height: "30px" }}
              />
              <Tab
                label="Lost"
                id="simple-tab-4"
                aria-controls="simple-tabpanel-4"
                sx={{ minHeight: "30px", height: "30px" }}
              />
              <Tab
                label="Contacts"
                id="simple-tab-5"
                aria-controls="simple-tabpanel-5"
                sx={{ minHeight: "30px", height: "30px" }}
              />
            </Tabs>
          </Box>

          <TabPanel value={tabIndex} index={0}>
            <Paper className="boxShadow">
              {/*Leads*/}
              <Box className="pmt-container-box">
                {/* <Box
        sx={{
          display: "flex",
          columnGap: 1,
          p: 2,
          borderBottom: 1,
          justifyContent: "flex-end",
        }}
      > */}
                {/*<Box className="pmt-title-box">
            <Box className="typography-title">
       <Typography>Leads1</Typography>
                </Box>
               */}
                {/* </Box> */}
                {/* <br /> */}
                {/* <br /> */}

                {/* <div>
                <CRMLeadsListCard
                  queryFiltersCompanyName={queryFilters.companyname}
                  queryFiltersIndustry={queryFilters.industry}
                  queryFiltersPriority={queryFilters.priority}
                  queryFiltersStage={queryFilters.stage}
                  queryFiltersSalesRep={queryFilters.sales_rep}
                  queryFiltersDesignation={queryFilters.designation}
                  queryFiltersState={queryFilters.state}
                />
              </div> */}
                <div className="react-table">
                  <BetterControlledTable
                    hasActionButtons={false}
                    getTableRows={getRows}
                    columns={tableDef}
                    perPage={25}
                    refreshCounter={crmTableRefreshCount}
                  />
                </div>
                <AddNewLeadDialog
                  open={createDialogOpen}
                  setOpen={setCreateDialogOpen}
                  employeesList={employeesList}
                  cloudRepsList={cloudRepsList}
                  onRefresh={refreshTable}
                  queryFilters={queryFilters.stage}
                  onQueryFilterChange={onQueryFilterChange}
                  tabIndex={tabIndex}
                />
              </Box>
              {/*Leads*/}
            </Paper>
          </TabPanel>
          <TabPanel value={tabIndex} index={1}>
            <Paper className="boxShadow">
              {/* <div>
              <CRMLeadsListCard
                queryFiltersCompanyName={queryFilters.companyname}
                queryFiltersIndustry={queryFilters.industry}
                queryFiltersPriority={queryFilters.priority}
                queryFiltersStage={queryFilters.stage}
                queryFiltersSalesRep={queryFilters.sales_rep}
                queryFiltersDesignation={queryFilters.designation}
                queryFiltersState={queryFilters.state}
              />
            </div> */}
              <div className="react-table">
                <BetterControlledTable
                  hasActionButtons={false}
                  getTableRows={getRows}
                  columns={tableDef}
                  perPage={25}
                  refreshCounter={crmTableRefreshCount}
                />
              </div>
              {/* <CloudRepList></CloudRepList> */}
            </Paper>
          </TabPanel>
          <TabPanel value={tabIndex} index={2}>
            <Paper className="boxShadow">
              {/* <div>
              <CRMLeadsListCard
                queryFiltersCompanyName={queryFilters.companyname}
                queryFiltersIndustry={queryFilters.industry}
                queryFiltersPriority={queryFilters.priority}
                queryFiltersStage={queryFilters.stage}
                queryFiltersSalesRep={queryFilters.sales_rep}
                queryFiltersDesignation={queryFilters.designation}
                queryFiltersState={queryFilters.state}
              />
            </div> */}
              <div className="react-table">
                <BetterControlledTable
                  hasActionButtons={false}
                  getTableRows={getRows}
                  columns={tableDef}
                  perPage={25}
                  refreshCounter={crmTableRefreshCount}
                />
              </div>
              {/* <CloudRepList></CloudRepList> */}
            </Paper>
          </TabPanel>
          <TabPanel value={tabIndex} index={3}>
            <Paper className="boxShadow">
              {/* <div>
              <CRMLeadsListCard
                queryFiltersCompanyName={queryFilters.companyname}
                queryFiltersIndustry={queryFilters.industry}
                queryFiltersPriority={queryFilters.priority}
                queryFiltersStage={queryFilters.stage}
                queryFiltersSalesRep={queryFilters.sales_rep}
                queryFiltersDesignation={queryFilters.designation}
                queryFiltersState={queryFilters.state}
              />
            </div> */}
              <div className="react-table">
                <BetterControlledTable
                  hasActionButtons={false}
                  getTableRows={getRows}
                  columns={tableDef}
                  perPage={25}
                  refreshCounter={crmTableRefreshCount}
                />
              </div>
              {/* <CloudRepList></CloudRepList> */}
            </Paper>
          </TabPanel>
          <TabPanel value={tabIndex} index={4}>
            <Paper className="boxShadow">
              {/* <div>
              <CRMLeadsListCard
                queryFiltersCompanyName={queryFilters.companyname}
                queryFiltersIndustry={queryFilters.industry}
                queryFiltersPriority={queryFilters.priority}
                queryFiltersStage={queryFilters.stage}
                queryFiltersSalesRep={queryFilters.sales_rep}
                queryFiltersDesignation={queryFilters.designation}
                queryFiltersState={queryFilters.state}
              />
            </div> */}
              <div className="react-table">
                <BetterControlledTable
                  hasActionButtons={false}
                  getTableRows={getRows}
                  columns={tableDef}
                  perPage={25}
                  refreshCounter={crmTableRefreshCount}
                />
              </div>
              {/* <CloudRepList></CloudRepList> */}
            </Paper>
          </TabPanel>
          <TabPanel value={tabIndex} index={5}>
            <Paper className="boxShadow">
              <CloudRepList></CloudRepList>
            </Paper>
          </TabPanel>
        </Box>
      </Box>
      <ItemDialogTabEmail
        open={itemDialogEmail}
        setOpen={setItemDialogEmail}
        onSubmit={onItemDialogEmailSubmit}
      />
      <ItemDialogTabCall
        open={itemDialogCall}
        setOpen={setItemDialogCall}
        onSubmit={onItemDialogCallSubmit}
      />
      <ItemDialogTabLinkedIn
        open={itemDialogLinkedIn}
        setOpen={setItemDialogLinkedIn}
        onSubmit={onItemDialogLinkedInSubmit}
      />
    </>
  );
}

function AddNewLeadDialog({
  open,
  setOpen,
  employeesList,
  onRefresh,
  cloudRepsList,
  queryFilters,
  onQueryFilterChange,
  tabIndex,
}) {
  const emptyNewLeadData = {
    company_name: "",
    email: "",
    linkedin_url: "",
    industry_value: "",
    project_name: "",
    priority: "",
    contact: "",
    stage_value: queryFilters,
    probability: "",
    address: "",
    project_description: "",
    estimated_budget: "",
    key_stakeholder: "",
    estimated_close_date: "",
    source: "",
    cloud_rep: "",
    arr: "",
    sales_rep: "",
    success_factor: "",
    vendor: "",
    cloud_rev: "",
    communication: "",
    communication: "",
    sales_rev: "",
    designation: "",
    country_code: "",
    state: "",
    city: "",
  };
  const user = useSelector((state) => state.user);
  const [data, setData] = useState(emptyNewLeadData);
  const [stageListData, setStageListData] = useState([]);
  const [stageNewListData, setStageNewListData] = useState([
    { stage_id: 3, stage_display: "Demo/Meeting", stage_value: 4 },
    { stage_id: 4, stage_display: "Proposal/SOW", stage_value: 5 },
    { stage_id: 5, stage_display: "Negotiation/Commitment", stage_value: 6 },
    { stage_id: 6, stage_display: "Opportunity Won", stage_value: 7 },
  ]);
  const [IndustryListData, setIndustryListData] = useState([]);
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({ defaultValues: emptyNewLeadData });
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const [stageValue, setStageValue] = useState("");

  useEffect(() => {
    if (open) {
      setStageValue(queryFilters);
    }
  }, [open, queryFilters]);
  // useEffect(() => {
  //   if (open) {
  //     setData(emptyNewLeadData);
  //   }
  // }, [open]);

  async function onNewLeadSubmit(newdata) {
    setLoader(true);
    newdata.stage_value = extractStageId(stageListData, stageValue);

    try {
      const { data } = await createCrmLeads(newdata, user.token);
      setLoader(false);
      dispatch(showAlert(data.msg));
      setOpen(false);
      onRefresh();
    } catch (err) {
      setLoader(false);
      handleAxiosError(err, dispatch);
      setOpen(false);
    }
  }
  useEffect(() => {
    industryList();
    stageList();
  }, []);
  async function industryList() {
    try {
      const { data } = await getIndustryList(user.token);
      setIndustryListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function stageList() {
    try {
      const { data } = await getStageList(user.token);
      setStageListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  async function onValueChange(data) {
    console.log("dattta-000", data);
    handleSubmit(onNewLeadSubmit);
  }

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      onClose={() => {
        //setOpen(false);
      }}
      className="dialog-box"
    >
      <DialogTitle>Create New {queryFilters.stage}</DialogTitle>
      <Box component="form" onSubmit={onNewLeadSubmit}>
        <DialogContent>
          <Grid
            container
            spacing={2}
            //  sx={{ pt: "1rem" }}
          >
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl
                fullWidth
                required
                error={Boolean(errors.industry_value)}
              >
                <InputLabel id="demo-simple-select-label-a">
                  Industry
                </InputLabel>
                <Controller
                  render={(props) => (
                    <Select value={props.value} onChange={props.onChange}>
                      {IndustryListData.map((c, i) => (
                        <MenuItem key={i} value={c.industry_value}>
                          {c.industry_display_value}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="industry_value"
                  control={control}
                  rules={{
                    required: "Please select Industry value",
                  }}
                />
                <FormHelperText>
                  {errors.industry_value?.message}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              {/* <FormControl
                fullWidth
                size="small"
                disabled={tabIndex === 3 ? false : true}
              >
                <InputLabel id="demo-simple-select-label" size="small">
                  Stage2
                </InputLabel>
                <Select
                  //className={classes.textfeild}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="stage_value"
                  // value={stage}
                  label="Stage"
                  size="small"
                  sx={{ background: "#fff" }}
                  // onChange={(e) => {
                  //   setStage(e.target.value);
                  // }}
                  value={queryFilters.stage}
                  onChange={onQueryFilterChange}
                >
                  {stageNewListData.map((s, i) => (
                    <MenuItem key={i} value={s.stage_display}>
                      {s.stage_display}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}

              <FormControl
                fullWidth
                error={Boolean(errors.stage_value)}
                disabled={tabIndex === 3 ? false : true}
              >
                <InputLabel id="demo-simple-select-label-a">Stage</InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      value={stageValue}
                      onChange={(e) => {
                        setStageValue(e.target.value);
                      }}
                    >
                      {tabIndex === 3
                        ? stageNewListData.map((s, i) => (
                            <MenuItem key={i} value={s.stage_display}>
                              {s.stage_display}
                            </MenuItem>
                          ))
                        : stageListData.map((s, i) => (
                            <MenuItem key={i} value={s.stage_display}>
                              {s.stage_display}
                            </MenuItem>
                          ))}
                    </Select>
                  )}
                  name="stage_value"
                  control={control}
                  rules={{
                    required: "Please select Stage value",
                  }}
                />
                <FormHelperText>{errors.stage_value?.message}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl fullWidth required error={Boolean(errors.priority)}>
                <InputLabel id="demo-simple-select-label-a">
                  Priority
                </InputLabel>
                <Controller
                  render={(props) => (
                    <Select value={props.value} onChange={props.onChange}>
                      <MenuItem value="1">1</MenuItem>
                      <MenuItem value="2">2</MenuItem>
                      <MenuItem value="3">3</MenuItem>
                      <MenuItem value="4">4</MenuItem>
                      <MenuItem value="5">5</MenuItem>
                    </Select>
                  )}
                  name="priority"
                  control={control}
                  rules={{
                    required: "Please select priority value",
                  }}
                />
                <FormHelperText>{errors.priority?.message}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Controller
                name="cloud_rep"
                control={control}
                rules={{
                  required: "Please select customer contact.", // Add the validation rule for the required field
                }}
                render={(props) => (
                  <SearchAndLoadMoreDropdown
                    value={props.value} // Use optional chaining here to handle the undefined case
                    onValueChange={(data) => {
                      if (data?.id) {
                        const selectedValue = cloudRepsList.find(
                          (c) => c.id === data.id
                        );

                        setValue("email", selectedValue?.email);
                        setValue("contact", selectedValue?.contact);
                        setValue("address", selectedValue?.address);
                        setValue("linkedin_url", selectedValue?.linkedin_url);
                        setValue("country_code", selectedValue?.country_code);
                        setValue("city", selectedValue?.city);
                        setValue("state", selectedValue?.state);
                        props.onChange(data.id);
                      } else {
                        setValue("cloud_rep", "");
                      }
                    }}
                  />
                )}
              />
              {/* Display error message if the field is invalid */}
              {errors.cloud_rep && (
                <Typography variant="body1" color="error">
                  {errors.cloud_rep.message}
                </Typography>
              )}
              {/* <SearchAndLoadMoreDropdown onValueChange={onValueChange} /> */}
              {/* <FormControl fullWidth required error={Boolean(errors.cloud_rep)}>
                <InputLabel id="demo-simple-select-label">
                  Customer Contact
                </InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      MenuProps={{ className: "select-box-height" }}
                      value={props.value}
                      label="Customer Contact"
                      onChange={(event) => {
                        const selectedValue = cloudRepsList.find(
                          (c) => c.id === event.target.value
                        );

                        setValue("email", selectedValue?.email);
                        setValue("contact", selectedValue?.contact);
                        setValue("address", selectedValue?.address);
                        setValue("linkedin_url", selectedValue?.linkedin_url);
                        setValue("country_code", selectedValue?.country_code);
                        setValue("city", selectedValue?.city);
                        setValue("state", selectedValue?.state);
                        props.onChange(event.target.value);
                      }}
                    >
                      {cloudRepsList.map((e, i) => (
                        <MenuItem key={i} value={e.id}>
                          {e.email}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="cloud_rep"
                  control={control}
                  // defaultValue=""
                  rules={{
                    required: "Please select customer contact",
                  }}
                />
                <FormHelperText>{errors.cloud_rep?.message}</FormHelperText>
              </FormControl> */}
              {/* <TextField
                name="cloud_rep"
                fullWidth
                label="Cloud Rep"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "Cloud Rep is required.",
                })}
                error={Boolean(errors.cloud_rep)}
                helperText={errors.cloud_rep?.message}
              /> */}
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="email"
                fullWidth
                label="Email"
                type="text"
                variant="outlined"
                inputRef={register({
                  // required: false,
                  required: "E-mail is required.",
                  pattern: {
                    value:
                      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    message: "Please enter a valid e-mail address.",
                  },
                })}
                error={Boolean(errors.email)}
                helperText={errors.email?.message}
                InputLabelProps={{ shrink: true }} // Added prop to float the label
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="designation"
                fullWidth
                label="Designation"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  //required: "Designation is required.",
                })}
                error={Boolean(errors.designation)}
                helperText={errors.designation?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl
                fullWidth
                // required
                error={Boolean(errors.country_code)}
              >
                <InputLabel id="demo-simple-select-label">
                  Country Code
                </InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      MenuProps={{ className: "select-box-height" }}
                      value={props.value}
                      label="Country Code"
                      onChange={props.onChange}
                    >
                      {CountryCodes.map((data, key) => (
                        <MenuItem key={key} value={data.code}>
                          +{data.code} {data.country}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="country_code"
                  control={control}
                  // defaultValue=""
                  rules={{
                    required: false,
                    // required: "Please select Country Code",
                  }}
                />
                <FormHelperText>{errors.country_code?.message}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="state"
                fullWidth
                label="State"
                type="text"
                inputRef={register({
                  required: false,
                  // required: "State is required.",
                })}
                // required
                error={Boolean(errors.state)}
                helperText={errors.state?.message}
                InputLabelProps={{ shrink: true }} // Added prop to float the label
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="city"
                fullWidth
                label="City"
                type="text"
                inputRef={register({
                  required: false,
                  // required: "City is required.",
                })}
                // required
                error={Boolean(errors.city)}
                helperText={errors.city?.message}
                InputLabelProps={{ shrink: true }} // Added prop to float the label
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="contact"
                fullWidth
                label="Contact"
                variant="outlined"
                type="tel"
                inputProps={{ maxLength: 10 }}
                inputRef={register({
                  required: false,
                  validate: (value) => {
                    if (value && value.length < 10) {
                      return "Please enter a valid number";
                    }
                    return true;
                  },
                })}
                // required
                error={Boolean(errors.contact)}
                helperText={errors.contact?.message}
                InputLabelProps={{ shrink: true }} // Added prop to float the label
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="address"
                fullWidth
                label="Address"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Address is required.",
                })}
                error={Boolean(errors.address)}
                helperText={errors.address?.message}
                InputLabelProps={{ shrink: true }} // Added prop to float the label
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl fullWidth required error={Boolean(errors.sales_rep)}>
                <InputLabel id="demo-simple-select-label">Sales Rep</InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      MenuProps={{ className: "select-box-height" }}
                      value={props.value}
                      label="Sales Rep"
                      onChange={props.onChange}
                    >
                      {employeesList.map((e, i) => (
                        <MenuItem key={i} value={e.id}>
                          {e.email}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="sales_rep"
                  control={control}
                  // defaultValue=""
                  rules={{
                    required: "Please select Sales rep",
                  }}
                />
                <FormHelperText>{errors.sales_rep?.message}</FormHelperText>
              </FormControl>
              {/* <TextField
                name="sales_rep"
                fullWidth
                label="Sales Rep"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "Sales Rep is required.",
                })}
                error={Boolean(errors.sales_rep)}
                helperText={errors.sales_rep?.message}
              /> */}
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="company_name"
                fullWidth
                label="Company"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Company is required.",
                })}
                error={Boolean(errors.company_name)}
                helperText={errors.company_name?.message}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="linkedin_url"
                fullWidth
                label="LinkedIn URL"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "LinkedIn URL is required.",
                  pattern: {
                    value:
                      /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile)/,
                    message: "Please enter a valid linkedin url.",
                  },
                })}
                error={Boolean(errors.linkedin_url)}
                helperText={errors.linkedin_url?.message}
                InputLabelProps={{ shrink: true }} // Added prop to float the label
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="project_name"
                fullWidth
                label="Project Name"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Project name is required.",
                })}
                error={Boolean(errors.project_name)}
                helperText={errors.project_name?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="project_description"
                fullWidth
                label="Project Description"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Project description is required.",
                })}
                error={Boolean(errors.project_description)}
                helperText={errors.project_description?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="source"
                fullWidth
                label="Source"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "source is required.",
                })}
                error={Boolean(errors.source)}
                helperText={errors.source?.message}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="arr"
                fullWidth
                label="ARR"
                type="number"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Arr is required.",
                })}
                error={Boolean(errors.arr)}
                helperText={errors.arr?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="vendor"
                fullWidth
                label="Vendor"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Vendor is required.",
                })}
                error={Boolean(errors.vendor)}
                helperText={errors.vendor?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="key_stakeholder"
                fullWidth
                label="Key Stakeholder"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "key stakeholder is required.",
                })}
                error={Boolean(errors.key_stakeholder)}
                helperText={errors.key_stakeholder?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="estimated_budget"
                fullWidth
                label="Estimated Budget($)"
                type="number"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Estimated budget is required.",
                })}
                error={Boolean(errors.estimated_budget)}
                helperText={errors.estimated_budget?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="probability"
                fullWidth
                label="Probability"
                type="number"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Probability is required.",
                })}
                error={Boolean(errors.probability)}
                helperText={errors.probability?.message}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl
                fullWidth
                error={Boolean(errors.estimated_close_date)}
              >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Controller
                    render={(props) => (
                      <DesktopDatePicker
                        value={props.value || ""}
                        shouldDisableDate={disablePrevDates(
                          dayjs(new Date()).subtract(1, "days").toJSON()
                        )}
                        label="Estimated Close Date"
                        onChange={props.onChange}
                        renderInput={(params) => (
                          <TextField
                            error={Boolean(errors.estimated_close_date)}
                            {...params}
                          />
                        )}
                      />
                    )}
                    rules={{
                      required: false,
                      // required: "Estimated Close Date is required.",
                    }}
                    name="estimated_close_date"
                    control={control}
                  />
                </LocalizationProvider>
                <FormHelperText>
                  {errors.estimated_close_date?.message}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="success_factor"
                fullWidth
                label="Success Factor"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Success Factor is required.",
                })}
                error={Boolean(errors.success_factor)}
                helperText={errors.success_factor?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="sales_rev"
                fullWidth
                label="Sales Rev"
                type="number"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Sales Rev is required.",
                })}
                error={Boolean(errors.sales_rev)}
                helperText={errors.sales_rev?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="cloud_rev"
                fullWidth
                label="Cloud Rev"
                type="number"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Cloud Rev is required.",
                })}
                error={Boolean(errors.cloud_rev)}
                helperText={errors.cloud_rev?.message}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                name="communication"
                fullWidth
                label="Communication"
                type="number"
                multiline={true}
                rows={5}
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Cloud Rev is required.",
                })}
                error={Boolean(errors.communication)}
                helperText={errors.communication?.message}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          {loader ? (
            <CircularProgress></CircularProgress>
          ) : (
            <Button
              disabled={/^Trial_User$/i.test(user.role) ? true : false}
              onClick={handleSubmit(onNewLeadSubmit)}
              type="submit"
              className="blue-button"
            >
              Submit
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  );
}
function disablePrevDates(startDate) {
  const startSeconds = Date.parse(startDate);
  return (date) => {
    return Date.parse(date) < startSeconds;
  };
}
function extractStageId(stageList, stage_display) {
  let obj = stageList.find((f) => stage_display === f.stage_display);
  return obj.stage_value;
}
